





































import { Component } from "vue-property-decorator";
import QuizPage from "../../components/QuizPage";
import DebugData from "../../components/DebugData.vue";
@Component({
  components: {
    DebugData
  }
})
export default class Biometric extends QuizPage {
  private created() {
    this.init("biometric", "/software");
    // Trigger onchange to update the frameworks in case the user went back,
    // changed some states, then came back here again.
    this.onChange();
  }
  // Biometric is different from other questions as it adds in frameworks based on
  // the US State selection in the previous question.
  private onChange(): void {
    console.log("biometric = ", this.selected);
    const frameworks = new Set<string>();
    if (this.selected == "yes") {
      const states = this.$store.state.statesSelection;
      if (states.includes("il")) {
        frameworks.add("BPIA");
      }
      if (states.includes("tx")) {
        frameworks.add("TBPL");
      }
      if (states.includes("wa")) {
        frameworks.add("HB1493");
      }
    }
    this.frameworks = frameworks;
  }
}
